import { getCurrentView } from '@utils/breakpoints';

export default class SeoModule {
  constructor(context) {
    this.elements = {
      module: context,
    };
    if (context.dataset.contentToggle == 'true') this.initToggleButton();
  }

  initToggleButton() {
    const { module } = this.elements;
    /*If toggle setting is set to true in ACF or theme settings...
        1) Create button element
        2) Get current view of page. This is used to determine where to insert the button element
        3) Insert button element depending on word length of each content block in the module, and current view of page
        4) Add event listeners to newly created element
    */
    const toggleButtonHTML = document.createElement('a'),
      wordLimit = getCurrentView() == 'med' || getCurrentView() == 'sml' ? 100 : 250,
      contentBlock1 = module.querySelectorAll('[data-word-length]')[0],
      contentBlock2 = module.querySelectorAll('[data-word-length]')[1] || null;
    toggleButtonHTML.classList.add('seo__module--toggle', 'p5');
    toggleButtonHTML.innerHTML = 'Show More';
    parseInt(contentBlock2?.getAttribute('data-word-length')) < wordLimit ? (contentBlock2.append(toggleButtonHTML), contentBlock2.querySelector('.seo__module--copy').classList.add('hidden')) : (contentBlock1.append(toggleButtonHTML), contentBlock2?.classList.add('hidden'));
    this.initToggleButtonListener();
  }
  initToggleButtonListener() {
    const { module } = this.elements;
    module.querySelector('.seo__module--toggle').addEventListener('click', (e) => {
      e.preventDefault();
      e.target.getAttribute('data-open') ? ((e.target.innerHTML = 'Show More'), e.target.removeAttribute('data-open')) : ((e.target.innerHTML = 'Show Less'), e.target.setAttribute('data-open', true));
      this.toggleContent(e.target);
    });
  }
  toggleContent(el) {
    const { module } = this.elements;
    if (module.classList.contains('legacy')) {
      //legacy JS functionality. only affects legacy-seo.liquid
      if (!el.getAttribute('data-open')) {
        module.querySelectorAll('.seo__module--excerpt').forEach((el) => {
          el.classList.remove('hidden');
        });
        module.querySelectorAll('.seo__module--copy').forEach((el) => {
          el.classList.add('hidden');
        });
      } else {
        module.querySelectorAll('.seo__module--excerpt').forEach((el) => {
          el.classList.add('hidden');
        });
        module.querySelectorAll('.seo__module--copy').forEach((el) => {
          el.classList.remove('hidden');
        });
      }
    } else {
      /*
        1) Determine location of the show more button
        2) Show / Hide content based off of current page view and state of the button
        3) Rearrange button orientation in the DOM if needed. Based off of word count 
    */
      const elLocation = el.parentNode.getAttribute('data-index');
      if (!el.getAttribute('data-open')) {
        //button says show more
        if (elLocation == '1' || parseInt(module.querySelector(`.seo__module--block[data-index="2"]`)?.getAttribute('data-word-length')) > 250) {
          module.querySelector(`.seo__module--block[data-index="2"]`)?.classList.add('hidden');
          el.remove();
          module.querySelector(`.seo__module--block[data-index="1"]`).append(el);
        }

        el.parentNode.querySelector('.seo__module--copy').classList.add('hidden');
        el.parentNode.querySelector('.seo__module--copy').classList.remove('active');

        if (getCurrentView() == 'sml' || getCurrentView() == 'med') {
          module.querySelectorAll(`.seo__module--excerpt.view--${getCurrentView()}`).forEach((el) => {
            el.classList.remove('hidden');
            el.parentNode.querySelector('.view--lrg').classList.remove('active');
          });
        }
      } else {
        //button says show less
        module.querySelectorAll('.seo__module--copy').forEach((el) => {
          el.classList.remove('hidden');
          el.classList.add('active');
        });

        if (getCurrentView() == 'sml' || getCurrentView() == 'med') {
          module.querySelectorAll(`.seo__module--excerpt.view--${getCurrentView()}`).forEach((el) => {
            el.classList.add('hidden');
            el.parentNode.querySelector('.view--lrg').classList.add('active');
          });
        }
        if (elLocation == '1') {
          module.querySelector(`.seo__module--block[data-index="2"]`).classList.remove('hidden');
          el.remove();
          module.querySelector(`.seo__module--block[data-index="2"]`).append(el);
        }
      }
    }
  }
}
